var map = {
	"./IconAddOutline.vue": "f785",
	"./IconAddress.vue": "aed4",
	"./IconArrowRight.vue": "b9bd",
	"./IconCheck.vue": "8a1d",
	"./IconContact.vue": "4e2e",
	"./IconDefi.vue": "8525",
	"./IconDefiShade.vue": "580a",
	"./IconDiscover.vue": "d7c5",
	"./IconEye.vue": "372c",
	"./IconEyeOff.vue": "1a65",
	"./IconFeedback.vue": "bdd3",
	"./IconGlobal.vue": "b8fa",
	"./IconHelps.vue": "d9a8",
	"./IconHfox.vue": "7ab9",
	"./IconInvite.vue": "4590",
	"./IconLoan.vue": "7ac8",
	"./IconMine.vue": "97ff",
	"./IconMixin.vue": "ec90",
	"./IconOrder.vue": "5d37",
	"./IconOtc.vue": "efef",
	"./IconPlus.vue": "8290",
	"./IconRefresh.vue": "b170",
	"./IconRegularInvest.vue": "e89b",
	"./IconSettings.vue": "2498",
	"./IconSwitch.vue": "5092",
	"./IconTools.vue": "eceb",
	"./IconTrade.vue": "4e89",
	"./IconWallet.vue": "3244",
	"./IconWyre.vue": "94eb",
	"./iconSwitchVertical.vue": "c0c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bed";